import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dialogMaxHeight"
};
const _hoisted_2 = {
  class: "dialogShrinkedWhenScrollbarOn"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_anonymous_workflow_submit = _resolveComponent("anonymous-workflow-submit");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createBlock(_component_el_form, {
    model: _ctx.fieldsToUpdate,
    "label-width": "auto",
    "label-position": "top",
    style: {
      "max-width": "100%"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_scrollbar, {
      "max-height": "410px"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_anonymous_workflow_submit, {
          onApproversUpdated: _ctx.setListUsers,
          "is-periodic": true
        }, null, 8, ["onApproversUpdated"])]),
        _: 1
      })])]),
      _: 1
    })]), _createVNode(_component_el_form_item, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_standard_button, {
        outlined: true,
        label: _ctx.$t('admin.dashboard.users.sidebar.deactivation.cancel'),
        onClick: _ctx.cancelReviewers
      }, null, 8, ["label", "onClick"]), _createVNode(_component_standard_button, {
        disabled: _ctx.usersListEmpty,
        label: _ctx.$t('admin.dashboard.users.sidebar.deactivation.ok'),
        onClick: _ctx.submitReviewers
      }, null, 8, ["disabled", "label", "onClick"])])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model"]);
}